import { Flex, Skeleton } from "@mantine/core"
import { useMediaQuery } from "@mantine/hooks"

export const FilterInputListSkeleton = () => {
	const isMobile = useMediaQuery("(max-width: 580px)")

	return (
		<Flex gap={32} w="100%" align="flex-start" wrap="wrap" direction={isMobile ? "column" : "row"}>
			<Skeleton height={50} w={isMobile ? "100%" : "304px"} />
			<Skeleton height={50} w={isMobile ? "100%" : "304px"} />
			<Skeleton height={50} w={isMobile ? "100%" : "304px"} />
		</Flex>
	)
}
